import { ReactNode } from "react";

/** Mono, uppercase section label ("COMPANY IDENTITY", "COMPANY RECORD", …). */
export const CompanySectionHeading = ({ children }: { children: ReactNode }) => (
  <h3 className="tw-font-mono tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-text-muted-foreground">
    {children}
  </h3>
);

interface CompanyFormLayoutProps {
  /** Left column: the stacked, divider-separated field sections. */
  main: ReactNode;
  /** Right column: the "Company record" panel (logo, status). */
  sidebar: ReactNode;
}

/**
 * Two-column drawer body shared by the company Register, Edit and Details
 * views: sections on the left, a tinted "Company record" side panel on the
 * right (stacked underneath on narrow screens).
 */
const CompanyFormLayout = ({ main, sidebar }: CompanyFormLayoutProps) => (
  <div className="tw-grid tw-grid-cols-1 lg:tw-min-h-[75vh] lg:tw-grid-cols-[minmax(0,1fr)_20rem]">
    <div className="tw-flex tw-flex-col tw-gap-8 tw-p-6 [&>section+section]:tw-border-t [&>section+section]:tw-border-border [&>section+section]:tw-pt-8">
      {main}
    </div>
    <aside className="tw-flex tw-flex-col tw-gap-5 tw-border-t tw-border-border tw-bg-muted/30 tw-p-6 lg:tw-border-l lg:tw-border-t-0">
      {sidebar}
    </aside>
  </div>
);

export default CompanyFormLayout;
